export default __webpack_public_path__ + "static/media/em_reg_no_ovaerlay.739a5e65.jpg";